import { HTTPRequest, ProjectHelper } from '@bimser/common';
import DataGrid2 from '../..';

type Operation = 'CheckColumnsIsUnique' | 'getRows' | 'DeleteRows' | 'InsertRows' | 'UpdateRow';

export const makeUrl = (dataGrid: DataGrid2, operation: Operation) => {
	const deploymentUrl = ProjectHelper.getDeploymentUrl(dataGrid.__form.projectName, null);
	const formName = dataGrid.__form.name;

	return `${deploymentUrl}/${formName}/GridOperations/${operation}`;
};

export const makeReq = <T>(url: string, args: any) =>
	HTTPRequest.post<T>(url, args, {
		headers: { 'Content-Type': 'application/json; charset=utf-8' },
		cache: true
	});
